import React, { ReactElement } from 'react';
import { TableMenuItem } from '@qualio/ui-components';
import { UserActionItems } from '../../../utils/umfe.enums';
import { InviteStatusMap, UserTableData } from '../../../types';

export const IndividualUserMenu = (
  handleUserAction: (actionItemId: string, userRow: UserTableData) => void,
  t: (key: string) => string,
): ReactElement => {
  return (
    <>
      <TableMenuItem
        data-cy="edit-user"
        id={UserActionItems.EDIT_USER.id}
        onClick={(userRow: UserTableData) => handleUserAction(UserActionItems.EDIT_USER.id, userRow)}
      >
        {t(UserActionItems.EDIT_USER.labelKey)}
      </TableMenuItem>
      <TableMenuItem
        data-cy="cancel-invite-user"
        id={UserActionItems.CANCEL_INVITE.id}
        onClick={(userRow: UserTableData) => handleUserAction(UserActionItems.CANCEL_INVITE.id, userRow)}
        isDestructive
        isHidden={(user: UserTableData) => user.inviteStatus !== InviteStatusMap.pending}
      >
        {t(UserActionItems.CANCEL_INVITE.labelKey)}
      </TableMenuItem>
      <TableMenuItem
        data-cy="resend-invite-user"
        id={UserActionItems.RESEND_INVITE.id}
        onClick={(userRow: UserTableData) => handleUserAction(UserActionItems.RESEND_INVITE.id, userRow)}
        isHidden={(user: UserTableData) => user.inviteStatus === InviteStatusMap.accepted}
      >
        {t(UserActionItems.RESEND_INVITE.labelKey)}
      </TableMenuItem>
      <TableMenuItem
        data-cy="remove-declined-user"
        id={UserActionItems.REMOVE_DECLINED_USER.id}
        onClick={(userRow: UserTableData) => handleUserAction(UserActionItems.REMOVE_DECLINED_USER.id, userRow)}
        isHidden={(user: UserTableData) => user.inviteStatus !== InviteStatusMap.declined}
        isDestructive
      >
        {t(UserActionItems.REMOVE_DECLINED_USER.labelKey)}
      </TableMenuItem>
      <TableMenuItem
        data-cy="remove-user"
        id={UserActionItems.REMOVE_USER.id}
        onClick={(userRow: UserTableData) => handleUserAction(UserActionItems.REMOVE_USER.id, userRow)}
        isHidden={(user: UserTableData) => user.inviteStatus !== InviteStatusMap.accepted}
        isDestructive
      >
        {t(UserActionItems.REMOVE_USER.labelKey)}
      </TableMenuItem>
    </>
  );
};
